import { Link } from 'react-router-dom';
import React, { useState } from 'react';
import { SERVICES_LIST } from './servicedata';

function Navbar() {
  const [showDropdown, setShowDropdown] = useState(false);
  
  return (
    <ul className="navbar-nav align-items-center justify-content-end flex-row" >
      <li className="nav-item">
        <Link className="nav-link px-3 white text-uppercase fw-medium " to="/">Home</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link px-3 py-0 white text-uppercase fw-medium" to="/about">About</Link>
      </li>
      <li className="nav-item">
        <Link className="nav-link px-3 py-0 white text-uppercase fw-medium" to="/projects">Projects</Link>
      </li>
      <li className={`nav-item dropdown ${showDropdown ? 'show' : ''}`} onMouseEnter={() => setShowDropdown(true)} 
        onMouseLeave={() => setShowDropdown(false)}>
        <Link className="nav-link dropdown-toggle px-3 py-0 white text-uppercase fw-medium" onClick={() => setShowDropdown(!showDropdown)} >Services</Link>
        <ul className={`dropdown-menu bg-grey p-0 border-0 mt-0 rounded1 bg-off-white ${showDropdown ? 'show' : ''}`}>
          
          {SERVICES_LIST.slice(0,7).map((service) => (
           
            <li key={service.id}>
              <Link 
                className="dropdown-item mt-0 pt-0 text-capitalize border-0 dark-grey" 
                to={service.path}
              >
                {service.title}
              </Link>
            </li>
          ))}
          <li>
            <Link className="dropdown-item text-capitalize border-0 dark-grey" to="/services">
              View More..
            </Link>
          </li>
        </ul>
        
      </li>
      <li className="nav-item">
        <Link className="nav-link px-3 py-0 white text-uppercase fw-medium" to="/contact">Contact</Link>
      </li>
    </ul>
  );
}

export default Navbar;